import styled from "styled-components";

export const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25px;

  .group-name {
    font-size: 1rem;
    margin: 0;
  }
`;
